import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SaveButton, DiscardButton } from '@components/common';

interface StationDevicesHeaderProps {
  hasUnsavedChanges: boolean;
  isSaving: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

export const StationDevicesHeader = ({
  hasUnsavedChanges,
  isSaving,
  onSave,
  onDiscard
}: StationDevicesHeaderProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        px: { xs: 2, sm: 3, md: 4 },
        py: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        position: 'sticky',
        top: 0,
        zIndex: 1
      }}
    >
      <Typography
        variant="h5"
        component="h1"
        sx={{
          fontWeight: 600,
          color: theme.palette.primary.main
        }}
      >
        {t('settings:stationDevices.title')}
      </Typography>

      {hasUnsavedChanges && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <DiscardButton
            onClick={onDiscard}
            disabled={isSaving}
            sx={{ minWidth: 'auto' }}
          />
          <SaveButton
            onClick={onSave}
            loading={isSaving}
            disabled={isSaving}
            sx={{ minWidth: 'auto' }}
          />
        </Box>
      )}
    </Box>
  );
};
